<nav #header class="fixed-top headerContainer" style="filter: drop-shadow(1px 1px 1px #6666664d);">
    <div class="logo-desktop">
        <a href="https://lastminutegalapagosdeals.com/" class="navbar-brand" style="justify-content: flex-start;"
            target="_blank">
            <img src="assets/images/logos-header/cdm.png" width="107" height="75" alt="logo" class="brand-logo">
        </a>
    </div>
    <div class="containerMenu" [ngClass]="showMenu ? 'showMenu':''">
        <ul class="navbar-nav">
            <li class="nav-item menuItem">
                <a href="https://lastminutegalapagosdeals.com/trusted-partners/" target="_blank">Our trusted
                    partners</a>
            </li>
        </ul>
    </div>
    <div class="social-media">
        <a href="https://x.com/thisiscarpedm" target="_blank"><i class="fa fa-twitter"></i></a>
        <a href="https://www.facebook.com/thisiscarpedm" target="_blank"><i class="fa fa-facebook"></i></a>
        <a href="https://www.instagram.com/thisiscarpedm" target="_blank"><i class="fa fa-instagram"></i></a>
        <a href="https://www.youtube.com/@gofarproject" target="_blank"><i class="fa fa-youtube-play"></i></a>
        <div *ngIf="companyParamsService.getFiltersInterest()" class="wishlist tooltip-container">
            <app-heart-header></app-heart-header>
        </div>
    </div>
    <a class="menuButton" (click)="renderMenu()" href="javascript:void()"><i class="fa fa-bars"></i></a>
</nav>
